import ValidationStrategy from './ValidationStrategy';

class FacebookValidationStrategy extends ValidationStrategy {
  static ALLOWED_TYPES = ['image/jpeg', 'image/png'];
  static MAX_FILE_SIZE_MB = 10;
  static MIN_DIMENSION = 200;
  static MAX_DIMENSION = 2048;

  validate(file) {
    const errors = [];

    // Vérifier le format (JPEG ou PNG uniquement)
    if (!FacebookValidationStrategy.ALLOWED_TYPES.includes(file.type)) {
      errors.push('Format de fichier invalide. Seuls les fichiers .jpg et .png sont autorisés.');
    }

    // Vérifier la taille du fichier (max 10MB)
    const fileSizeMB = file.size / (1024 * 1024);
    if (fileSizeMB > FacebookValidationStrategy.MAX_FILE_SIZE_MB) {
      errors.push(`Le fichier est trop volumineux (${fileSizeMB.toFixed(1)}MB). Taille maximum autorisée : ${FacebookValidationStrategy.MAX_FILE_SIZE_MB}MB.`);
    }

    // Vérifier les dimensions de l'image
    return new Promise((resolve) => {
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);

      const cleanupAndResolve = (result) => {
        URL.revokeObjectURL(objectUrl);
        resolve(result);
      };

      img.onload = () => {
        const { width, height } = img;
        
        // Vérifier les dimensions (200x200px min, 2048x2048px max)
        if (width < FacebookValidationStrategy.MIN_DIMENSION || height < FacebookValidationStrategy.MIN_DIMENSION) {
          errors.push(`L'image est trop petite (${width}x${height}px). Dimensions minimum requises : ${FacebookValidationStrategy.MIN_DIMENSION}x${FacebookValidationStrategy.MIN_DIMENSION}px.`);
        }
        
        if (width > FacebookValidationStrategy.MAX_DIMENSION || height > FacebookValidationStrategy.MAX_DIMENSION) {
          errors.push(`L'image est trop grande (${width}x${height}px). Dimensions maximum autorisées : ${FacebookValidationStrategy.MAX_DIMENSION}x${FacebookValidationStrategy.MAX_DIMENSION}px.`);
        }

        cleanupAndResolve({
          isValid: errors.length === 0,
          errorMessage: errors.length > 0 ? errors.join(' ') : null
        });
      };
      
      img.onerror = () => {
        errors.push('Erreur lors de la lecture de l\'image. Veuillez vérifier que le fichier est valide.');
        cleanupAndResolve({
          isValid: false,
          errorMessage: errors.join(' ')
        });
      };
      
      img.src = objectUrl;
    });
  }

  getHelpMessage() {
    return `Formats acceptés : .jpg, .png | Taille : ${FacebookValidationStrategy.MIN_DIMENSION}x${FacebookValidationStrategy.MIN_DIMENSION}px min, ${FacebookValidationStrategy.MAX_DIMENSION}x${FacebookValidationStrategy.MAX_DIMENSION}px max | Poids : ${FacebookValidationStrategy.MAX_FILE_SIZE_MB}MB max`;
  }
}

export default FacebookValidationStrategy;
